import md5 from 'crypto-js/md5';
import sha1 from 'crypto-js/sha1';
import sha256 from 'crypto-js/sha256';

import { APP_LIVE_RAMP_IT, APP_LIVE_RAMP_PID, APP_LIVE_RAMP_REFRESH_IT } from '../constants';

export const buildLiveRampQueryParams = ({ email, envelope }: { email?: string; envelope?: string }): string => {
  let params = [['pid', APP_LIVE_RAMP_PID]];

  if (email) {
    params = [
      ...params,
      ['it', APP_LIVE_RAMP_IT],
      ['iv', sha1(email).toString()],
      ['it', APP_LIVE_RAMP_IT],
      ['iv', sha256(email).toString()],
      ['it', APP_LIVE_RAMP_IT],
      ['iv', md5(email).toString()],
    ];
  }
  if (envelope) {
    params = [...params, ['it', APP_LIVE_RAMP_REFRESH_IT], ['iv', envelope]];
  }

  const connectedParams = params.map(param => param.join('='));

  return `?${connectedParams.join('&')}`;
};
